import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CaseIdSchema, EmailSchema, InvitationIdSchema, type CaseRole } from '@casetrace/shared';
import { deleteInvitation, inviteMember, listCaseMembers } from '../../lib/callables';

export function useCaseMembers(caseId: string) {
  return useQuery({
    queryKey: ['case-members', caseId],
    queryFn: () => listCaseMembers({ caseId: CaseIdSchema.parse(caseId) }),
  });
}

export function useInviteMember(caseId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: { readonly email: string; readonly role: CaseRole }) =>
      inviteMember({
        caseId: CaseIdSchema.parse(caseId),
        email: EmailSchema.parse(input.email),
        role: input.role,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['case-members', caseId] });
    },
  });
}

export function useDeleteInvitation(caseId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invitationId: string) =>
      deleteInvitation({
        invitationId: InvitationIdSchema.parse(invitationId),
      }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['case-members', caseId] }),
        queryClient.invalidateQueries({ queryKey: ['my-invitations'] }),
      ]);
    },
  });
}
